import styled from 'styled-components';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import TextButton from '@front/web-ui/src/components/button/text-button';
import Skeleton from '@front/web-ui/src/components/skeleton/skeleton';

import { calculationLineStyle } from '../../../../../common/common';

const PriceLineWrapper = styled.div`
  ${calculationLineStyle}
`;

type PriceLineProps = {
  text: string;
  price: string;
  isPriceStrikedOut?: boolean;
  isBold?: boolean;
  isLoading: boolean;
};

export const PriceLine = ({ text, price, isPriceStrikedOut = false, isBold = false, isLoading }: PriceLineProps) => {
  const TextLine = isBold ? Text.MDBold : Text;

  return (
    <PriceLineWrapper>
      <TextLine>{text}</TextLine>
      {isLoading ? <Skeleton linesWidth={['50px']} /> : <TextLine strikedOut={isPriceStrikedOut}>{price}</TextLine>}
    </PriceLineWrapper>
  );
};

type PriceLineTextButtonProps = {
  text: string;
  price: string;
  onPress: (val?: any) => void;
  isLoading: boolean;
};

export const PriceLineTextButton = ({ text, price, onPress, isLoading }: PriceLineTextButtonProps) => (
  <PriceLineWrapper>
    <TextButton onClick={onPress}>{text}</TextButton>
    {isLoading ? <Skeleton linesWidth={['50px']} /> : <Text>{`- ${price}`}</Text>}
  </PriceLineWrapper>
);
